
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/biostrength",
      function () {
        return require("private-next-pages/biostrength.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/biostrength"])
      });
    }
  